import React, { useEffect, useState } from 'react';
import { Card, Nav, Tab } from 'react-bootstrap';
import { FlexRow } from 'motion-components';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { GlobalParamsSection } from './global';
import { EntityParamsSection } from './entity';

const TAB_GLOBAL = 'global';
const TAB_ENTITY = 'entity';
const PARAMS_ACTIVE_TAB_KEY = 'params.activeTab';
function getSavedActiveTab(): string {
  try {
    const saved = sessionStorage.getItem(PARAMS_ACTIVE_TAB_KEY);
    return saved === TAB_ENTITY ? TAB_ENTITY : TAB_GLOBAL;
  } catch (_error) {
    return TAB_GLOBAL;
  }
}

function saveActiveTab(tab: string): void {
  try {
    sessionStorage.setItem(PARAMS_ACTIVE_TAB_KEY, tab);
  } catch (_error) {
    // ignore storage errors (private mode, blocked storage, etc.)
  }
}

/* ----------------------------------------------------------- */
/* ------------------------ Page ----------------------------- */
export const ParamsPage = observer(() => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<string>(getSavedActiveTab);

  useEffect(() => {
    saveActiveTab(activeTab);
  }, [activeTab]);

  return (
    <Card className="shadow">
      <Card.Header>
        <FlexRow>
          <Card.Title className="m-0">{t('Ρύθμιση Παραμέτρων')}</Card.Title>
        </FlexRow>
      </Card.Header>

      <Card.Body className="nopadding">
        <Tab.Container
          id="params-tabs"
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k ?? TAB_GLOBAL)}
        >
          <Nav variant="tabs" className="px-3 pt-2">
            <Nav.Item>
              <Nav.Link eventKey={TAB_GLOBAL}>{t('Καθολικές Παράμετροι')}</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey={TAB_ENTITY}>{t('Ανά Τύπο Παραλήπτη')}</Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content className="p-3">
            <Tab.Pane eventKey={TAB_GLOBAL} mountOnEnter unmountOnExit>
              <GlobalParamsSection />
            </Tab.Pane>
            <Tab.Pane eventKey={TAB_ENTITY} mountOnEnter unmountOnExit>
              <EntityParamsSection />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </Card.Body>
    </Card>
  );
});
